import React, { Component } from 'react'
import moment from 'moment'
import StatusBar from '../common/StatusBar'
import ActionsRow from './ActionsRow'
import { Link } from 'react-router-dom';
import _ from 'lodash'
import DateCaso from './DateCaso'

class Table extends Component {
    renderRows(){
        if(_.isEmpty(this.props.casos)){
            return(<div>loading</div>)
        }

        return this.props.casos.map((caso) => {
            let rowClassName = caso.archived === 1 && !this.props.isAdmin ? "archived  alert-warning" : ""
            return (
                <tr key={caso.id} className={rowClassName}>
                    <td>
                        <Link className="panel-block" to={"/casos/" + caso.id}>
                            {caso.archived === 1 ?
                                <i className="fa fa-archive text-warning"></i>
                            :
                                <i className="fa fa-file-o"></i>
                            } <b>{caso.title}</b>&nbsp;
                        </Link>
                    </td>
                    <td className="text-muted">
                        {moment(caso.created_at).format('DD-MM-YYYY') }
                    </td>
                    <td className="text-muted">
                        <DateCaso caso={caso} />
                    </td>
                    <td>
                        <StatusBar
                            status={caso.status}
                            partialDelivery={caso.partial_delivery}
                            casoId={caso.id}
                        />
                    </td>
                    <td>
                        <ActionsRow
                            archived={caso.archived}
                            casoToArchive={this.props.casoToArchive}
                            casoId={caso.id}
                            isAdmin={this.props.isAdmin}
                            removeCaso={this.props.removeCaso.bind(this)}
                        />
                    </td>
                </tr>
            );
        })
    }
    render(){
        if(!_.isEmpty(this.props.casos)){
            return(
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th
                            scope="col"
                            className={this.props.sort === "title" ? "th-order active" : "th-order" }
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("title", order)
                            }}
                        >Paciente <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "created_at" ? "th-order active" : "th-order" }
                            style={{width:"15%"}}
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("created_at", order)

                            }}
                        >Fecha de inicio <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "entrega" ? "th-order active" : "th-order" }
                            style={{width:"15%"}}
                            id="entrega"
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("entrega", order)
                            }}
                        >Fecha de entrega <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "status" ? "th-order active" : "th-order" }
                            style={{width:"20%"}}
                            id="status"
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("status", order)
                            }}
                        >Estado <i className="fa fa-sort fa-1"></i></th>
                        <th style={{width:"1%"}}>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderRows()}
                    </tbody>
                </table>
            )
        }else{
            return(
                <div className="alert alert-secondary" role="alert">
                    No existen casos con los criterios de búsqueda seleccionados
                </div>
            )
        }

    }
}
export default Table


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/Table.jsx